import { NgModule } from '@angular/core';
import { EditFoodPage } from 'pages/edit-food/edit-food';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [EditFoodPage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class EditFoodPageModule {}
